import React from "react";
import numeral from "numeral";
import NumberUtils from "util/NumberUtils";
const IndexSizeSummary = ({ index }) => {
  if (index.size) {
    return /* @__PURE__ */ React.createElement("span", null, "(", NumberUtils.formatBytes(index.size.bytes), " / ", numeral(index.size.events).format("0,0"), " messages)", " ");
  }
  return /* @__PURE__ */ React.createElement("span", null);
};
export default IndexSizeSummary;
